import axiosInstance from "../../../config/axiosConfig";

export interface AddressDetails {
  id?: string;
  leadId: string;
  applicationId: string;
  type: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  latitude?: number;
  longitude?: number;
  active: boolean;
  verified: boolean;
  landmark?: string;
  postalCode: number;
  ownership: string;
  monthlyRent?: number;
  yearsOfStay: number;
}

export interface AddressResponse {
  applicationId: string;
  id: string;
  leadId: string;
  type: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  latitude?: number;
  longitude?: number;
  active: boolean;
  verified: boolean;
  landmark?: string;
  postalCode: number;
  ownership: string;
  monthlyRent?: number;
  yearsOfStay: number;
}

export interface GetAddressesResponse {
  addresses: AddressResponse[];
  count: number;
}

export const addressService = {
  createAddress: async (addressData: AddressDetails): Promise<AddressResponse> => {
    try {
      const response = await axiosInstance.post("/applications/addresses", addressData);
      return response.data;
    } catch (error) {
      console.error("Error creating address:", error);
      throw error;
    }
  },

  getAddressesByApplicationId: async (applicationId: string): Promise<GetAddressesResponse> => {
    try {
      const response = await axiosInstance.get(`/applications/addresses?applicationId=${applicationId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching addresses:", error);
      throw error;
    }
  },

  getAddressById: async (applicationId: string, addressId: string): Promise<AddressResponse> => {
    try {
      const response = await axiosInstance.get(`/applications/addresses?applicationId=${applicationId}`);
      const address = response.data.addresses.find((address: AddressResponse) => address.id === addressId);
      
      if (!address) {
        throw new Error(`Address with ID ${addressId} not found`);
      }
      
      return address;
    } catch (error) {
      console.error(`Error fetching address with ID ${addressId}:`, error);
      throw error;
    }
  },

  updateAddress: async (addressData: AddressDetails): Promise<AddressResponse> => {
    try {
      const response = await axiosInstance.post(`/applications/addresses`, addressData);
      return response.data;
    } catch (error) {
      console.error("Error updating address:", error);
      throw error;
    }
  },

  deleteAddress: async (addressId: string): Promise<void> => {
    try {
      await axiosInstance.delete(`/applications/address?id=${addressId}`);
    } catch (error) {
      console.error("Error deleting address:", error);
      throw error;
    }
  }
};
